export const Routes = {
  StackBuilder: 'stack-builder',
  WallStorageBuilder: 'wall-storage-builder',
  GetInspired: 'get-inspired',
};
